import { AppDispatch, RootState } from 'helpers/store';
import { TypedUseSelectorHook, useDispatch, useSelector as useSelectorRedux } from 'react-redux';

type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelectorRedux;

// Export notification hook
export { useNotification } from './useNotification';
// Export models hook
export { useModels } from './useModels';
